exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_AttachmentsContainer_2vMrCbBzxNyVCdPLF4ZFv4 {\n  margin: 45px 40px 20px 40px;\n}\n\n.IA_AttachmentsAttachment_3Ev2pmgihoDENOx_5CugkP {\n  display: flex;\n  align-items: center;\n}\n\n.IA_AttachmentsLink_3d90oVA6GFzMi6pOf0TUVR {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_AttachmentsContainer": "IA_AttachmentsContainer_2vMrCbBzxNyVCdPLF4ZFv4",
	"IA_AttachmentsAttachment": "IA_AttachmentsAttachment_3Ev2pmgihoDENOx_5CugkP",
	"IA_AttachmentsLink": "IA_AttachmentsLink_3d90oVA6GFzMi6pOf0TUVR"
};